import { RootState } from '../../store';

export const getTimezones = (state: RootState): any[] =>
  state?.timezones?.timezoneList || [];
